import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { AndonCauseCode } from './andon-cause-code';
import { environment } from '../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class AndonCauseCodeService {

  errMessage = '';

// private CauseCodeUrl = 'api/andonCauseCode';  // Web APIのURL

  constructor(
    private http: HttpClient ) { }

  /** サーバーから取得する */
  getCauseCode ( AndonID: number ): Observable<AndonCauseCode[]> {
    return this.http.get<AndonCauseCode[]>( environment.apiUrl + 'CauseCode/List/' + AndonID.toString )
      .pipe(
  //      tap(List => this.log(`fetched List`)),
        catchError(this.handleError('getCauseCode', []))
      );
  }
   /**
   * 失敗したHttp操作を処理します。
   * アプリを持続させます。
   * @param operation - 失敗した操作の名前
   * @param result - observableな結果として返す任意の値
   */
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: リモート上のロギング基盤にエラーを送信する
      console.error(error); // かわりにconsoleに出力

      // TODO: ユーザーへの開示のためにエラーの変換処理を改善する
      this.log(`${operation} failed: ${error.message}`);

      // 空の結果を返して、アプリを持続可能にする
      return of(result as T);
    };
  }

  /** HeroServiceのメッセージをMessageServiceを使って記録 */
  private log(message: string) {
    console.error('AndonCauseCode: ' + message);
    alert(this.errMessage);
  }
}
